/**
 * When true, Secure app redirects users to the billing app and logs to Airbrake (with referrer)
 * so we can find and update direct links to the secure app.
 * Hardcoded false for now (no Statsig in Secure app).
 */
export const useSecureAppBlock = (): boolean => false;
